import { render, staticRenderFns } from "./Failed.vue?vue&type=template&id=ce2562bc&scoped=true"
import script from "./Failed.vue?vue&type=script&lang=js"
export * from "./Failed.vue?vue&type=script&lang=js"
import style0 from "./Failed.vue?vue&type=style&index=0&id=ce2562bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2562bc",
  null
  
)

export default component.exports